import { defineComponent as _defineComponent } from 'vue';
import { ref, inject, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { EnMenu, EnMenuItem } from '../../base/EnMenu';
import { EnButton } from '../../base/EnButton';
import { EllipsisIcon } from 'lucide-vue-next';
import { RotateCw as RefreshIcon } from 'lucide-vue-next';
import { useIdBuilder } from '../composables/useIdBuilder';
import { useSlots } from 'vue';
import { EnOverlayBadge } from 'Components/badge/EnOverlayBadge';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnDatagridActionsMenu',
    props: {
        staticId: {
            type: String,
        },
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const { t } = useI18n();
        const props = __props;
        const menuComponent = ref();
        const { loadItems } = inject('reload', () => {
        });
        const { buildId } = useIdBuilder();
        const button = ref();
        function reload() {
            loadItems();
            closeMenu();
        }
        function closeMenu() {
            menuComponent.value.setOpen(false);
        }
        const batchProcessItemCount = inject('batchProcessItemCount');
        const batchProcessTitle = inject('batchProcessTitle');
        const slots = useSlots();
        const hasModuleSpecificActions = computed(() => !!slots.moduleSpecificActions);
        const hasBatchProcessActions = computed(() => !!slots.batchProcessActions);
        const __returned__ = { t, props, menuComponent, loadItems, buildId, button, reload, closeMenu, batchProcessItemCount, batchProcessTitle, slots, hasModuleSpecificActions, hasBatchProcessActions, get EnMenu() { return EnMenu; }, get EnMenuItem() { return EnMenuItem; }, get EnButton() { return EnButton; }, get EllipsisIcon() { return EllipsisIcon; }, get RefreshIcon() { return RefreshIcon; }, get EnOverlayBadge() { return EnOverlayBadge; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
